<template>
  <div class="airplaneBox" @click="clickAll" v-if="rawData || errorMsg">
    <div class="outSideBox">
      <div class="contentBox">
        <div class="titleBox">
          <img
            src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/airplaneIcon.png"
            alt=""
            class="takeTaxiIcon"
          />
          <div class="titleText">机票</div>
        </div>
        <div class="infoBox" :class="{ isExpire: isExpire }" v-if="rawData">
          <div class="item">
            <span class="label">时间</span>
            <span class="text">{{ rawData.date }}</span>
          </div>
          <div class="item">
            <span class="label">地点</span>
            <span class="text">{{ rawData.start }}-{{ rawData.end }}</span>
          </div>
        </div>
        <div class="list" :class="{ isExpire: isExpire }" v-if="rawData">
          <div class="listItem" v-for="(value, key) in rawData.list" :key="key">
            <div class="p1">
              <div class="left">
                <div class="start">
                  <div class="time">{{ value.startTime }}</div>
                  <div class="city">
                    {{ value.startAirportCh }}{{ value.startTerminalEn }}
                  </div>
                </div>
                <div class="center">
                  <div class="text">{{ calcFilghtDuration(value).str }}</div>
                  <img
                    class="specialArrowIcon"
                    src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/specialArrowIcon.png"
                    alt=""
                  />
                </div>
                <div class="end">
                  <div class="time">{{ value.endTime }}</div>
                  <div class="city">
                    {{ value.endAirportCh }}{{ value.endTerminalEn }}
                  </div>
                </div>
                <div class="day" v-if="calcFilghtDuration(value).day > 0">
                  +{{ calcFilghtDuration(value).day }}天
                </div>
              </div>
              <div class="rightPriceBox">
                <span>查价</span>
              </div>
            </div>
            <div class="p2">
              <div class="p2_item">
                {{ value.flightAirwaysCh }}{{ value.flightId }}
              </div>
              <div class="p2_item" v-show="value.flightPlaneCn">|</div>
              <div class="p2_item">{{ value.flightPlaneCn }}</div>
            </div>
          </div>
        </div>
        <!-- 暂无班次 -->
        <div
          :class="{ isExpire: isExpire }"
          class="noDataBox"
          v-if="rawData && rawData.list.length == 0 && errorMsg == ''"
        >
          <div class="topLine"></div>
          <img
            class="noDataIcon"
            src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/noSchDataIcon.png"
            alt=""
          />
          <div class="text">暂无班次</div>
        </div>
        <!-- 错误信息 -->
        <div
          class="errorMsgBox"
          v-if="errorMsg != ''"
          :class="{ isExpire: isExpire }"
        >
          {{ errorMsg }}
        </div>
        <div class="bottomBar" :class="{ isExpire: isExpire }">
          <div class="moreBox">
            <div class="text">查看更多</div>
            <img
              class="right_arrow_gray"
              src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/right_arrow_gray.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const config = {
  dxlc: {
    test_app: "https://m.ly.com/ft/touch/index?platcode=518&refId=2000020811",
    prod_app: "https://m.ly.com/ft/touch/index?platcode=518&refId=2000020811",
    test_wechat:
      "wxmp://appId=wx336dcaf6a1ecf632&path=/page/home/index/index?wxrefid=2000020811&tab=1",
    prod_wechat:
      "wxmp://appId=wx336dcaf6a1ecf632&path=/page/home/index/index?wxrefid=2000020811&tab=1",
  },
  cxnt: {
    test_app: "https://m.ly.com/ft/touch/index?platcode=518&refId=2000118572",
    prod_app: "https://m.ly.com/ft/touch/index?platcode=518&refId=2000118572",
    test_wechat:
      "wxmp://appId=wx336dcaf6a1ecf632&path=/page/home/index/index?wxrefid=2000118572&tab=1",
    prod_wechat:
      "wxmp://appId=wx336dcaf6a1ecf632&path=/page/home/index/index?wxrefid=2000118572&tab=1",
  },
};
const env = process.env.VUE_APP_ENV;
export default {
  props: ["businessContent"],
  data: function () {
    return {
      isExpire: false,
      timer: null,
      type: null,
      rawData: null,
      bizReq: null,
      errorMsg: "",
    };
  },
  mounted: function () {
    if (this.businessContent.bizCode == "SUCCESS") {
      this.type = this.businessContent.type;
      this.rawData = JSON.parse(this.businessContent.bizData);
      this.channel = this.businessContent.channel;
      this.bizReq = JSON.parse(this.businessContent.bizReq);
      console.log(this.rawData);
    } else {
      this.errorMsg = this.businessContent.bizMsg;
    }
    this.checkIsExpire(this.businessContent);
  },
  methods: {
    // 检测卡片是否过期
    checkIsExpire: function (businessContent) {
      let expireTime = new Date(
        businessContent.expireTime.replace(/-/g, "/")
      ).getTime();
      let nowTime = new Date().getTime();
      if (nowTime > expireTime) {
        this.isExpire = true;
      } else {
        console.log("卡片过期时间", expireTime - nowTime);
        this.timer = setTimeout(() => {
          this.isExpire = true;
          clearTimeout(this.timer);
          this.timer = null;
        }, expireTime - nowTime);
      }
    },
    // 点击整个卡片
    clickAll: function () {
      if (this.isExpire) {
        this.$toast("已失效");
        setTimeout(() => {
          this.jumpPage();
        }, 1000);
      } else {
        this.jumpPage();
      }
    },
    // 跳到h5或者小程序原生
    jumpPage: function () {
      // 如果是小程序
      if (window.__wxjs_environment) {
        let url = `/pages/JumpThirdWechatProgram/JumpThirdWechatProgram?url=${encodeURIComponent(
          config[this.businessContent.channel][env + "_wechat"]
        )}`;
        wx.miniProgram.navigateTo({
          url,
        });
      }
      // 否则是app环境
      else {
        let url = config[this.businessContent.channel][env + "_app"];
        url = url + `&thirdMemberId=${window.localStorage.getItem("appId_AI")}`;
        window.location.href = url;
      }
    },
    // 计算飞行时间和是否跨天
    calcFilghtDuration: function (value) {
      function getTimeDifference(timestamp1, timestamp2) {
        const diffMs = Math.abs(timestamp1 - timestamp2); // 绝对值，防止负数
        const minuteMs = 60 * 1000;
        const hourMs = 60 * minuteMs;
        const dayMs = 24 * hourMs;
        const day = Math.floor(diffMs / dayMs);
        const hour = Math.floor((diffMs % dayMs) / hourMs);
        const minute = Math.floor((diffMs % hourMs) / minuteMs);
        let str = "";
        if (day > 0) {
          str = str + day + "天";
        }
        if (hour > 0) {
          str = str + hour + "小时";
        }
        if (minute > 0) {
          str = str + minute + "分";
        }
        return { day, hour, minute, str };
      }
      function formatDateTime(dateStr, timeStr) {
        // 解析年月日
        const year = dateStr.slice(0, 4);
        const month = dateStr.slice(4, 6);
        const day = dateStr.slice(6, 8);
        // 解析时分
        const [hour, minute] = timeStr.split(":");
        // 构建格式化字符串
        return `${year}/${month}/${day} ${hour}:${minute}:00`;
      }
      let startDate = new Date(
        formatDateTime(value.startDate, value.startTime)
      );
      let endDate = new Date(formatDateTime(value.endDate, value.endTime));
      let result = getTimeDifference(startDate, endDate);
      return result;
    },
  },
  destroyed: function () {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./airplaneBox.scss";
</style>
